import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';

const properties = [
  { id: 1, name: "Luxury Duplex", location: "Sagamu/Ikenne", img: "placeholder1.jpg" },
  { id: 2, name: "3-bedroom", location: "Ikenne", img: "images/about2.jpg" },
  { id: 3, name: "2-bedroom", location: "Ikenne", img: "placeholder2.jpg" },
  { id: 4, name: "Mini Flat", location: "Ikenne", img: "placeholder2.jpg" },
  { id: 2, name: "Selfcon", location: "Ikenne", img: "placeholder2.jpg" },
  { id: 5, name: "Acres of Land", location: "Sagamu", img: "placeholder3.jpg" },
  { id: 6, name: "Plots of Land", location: "Ikenne", img: "placeholder3.jpg" },
];

const BookTour = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', property: '' });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Submitting...");

    const formResponse = await fetch("https://formspree.io/f/xnnqvlqw", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (formResponse.ok) {
      setStatus("Thank you! Your tour request has been submitted.");
      setFormData({ name: '', email: '', phone: '', property: '' });
    } else {
      setStatus("Oops! There was an error submitting your request.");
    }
  };

  return (
    <section className="book-tour" data-aos="slide-up">
      <h2>Book a Tour With Us</h2>
      
      <form onSubmit={handleSubmit} className="tour-form">
        <label>
          Name:
          <input type="text" name="name" value={formData.name} onChange={handleChange} required />
        </label>
        <label>
          Email:
          <input type="email" name="email" value={formData.email} onChange={handleChange} required />
        </label>
        <label>
          Phone:
          <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
        </label>
        <label>
          Interested Property:
          <select name="property" value={formData.property} onChange={handleChange} required>
            <option value="">Select a property</option>
            {properties.map((property) => (
              <option key={property.id} value={property.name}>{property.name} - {property.location}</option>
            ))}
          </select>
        </label>
        <button type="submit">Submit</button>
        <p>{status}</p> 
      </form>

      <footer className="contact-info">
        <h4>Contact Us</h4>
        <p><FaPhone /> +234 803 243 5855</p>
        <p><FaEnvelope /> mayowapeters18@gmail.com</p>
        <div className="social-icons">
          <a href="https://facebook.com"><FaFacebook /></a>
          <a href="https://instagram.com"><FaInstagram /></a>
          <a href="https://twitter.com"><FaTwitter /></a>
        </div>
      </footer>
    </section>
  );
};

export default BookTour;
